import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import withOverlay from '../../common/withOverlay';
import { ACTUAL_VS_PLANNED_PROPERTY, PROP_TYPES } from '../constants';
import { getMaxDurationOfStopInMinutes } from '../helper';
import RouteCard from './RouteCard';

function ActualVsPlannedCard({ routeData, users, selectedUserIds, selectedDate, onStopClicked }) {
  const { actual, planned, isLoading } = routeData;
  const maxDurationFoundInStops = getMaxDurationOfStopInMinutes(routeData);
  const user = useMemo(() => {
    if (!selectedUserIds || !selectedUserIds[0]) {
      return null;
    }
    return users.find((u) => u.id === selectedUserIds[0]);
  }, [users, selectedUserIds]);
  return (
    <div className="joyn2-grid" id="actual-vs-planned-card">
      {isLoading ? (
        <div className="hover-loading">
          <div className="joyn2-loader" />
        </div>
      ) : (
        <>
          <ActualVsPlannedCardHeader user={user} selectedDate={selectedDate} />
          <div className="route-cards" style={{ height: '80%', display: 'flex' }}>
            <div style={{ width: '50%' }}>
              <PlannedRouteCard maxDuration={maxDurationFoundInStops} data={planned} onStopClicked={onStopClicked} />
            </div>
            <div style={{ width: '50%' }}>
              <ActualRouteCard maxDuration={maxDurationFoundInStops} data={actual} onStopClicked={onStopClicked} />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const userPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
});

ActualVsPlannedCard.propTypes = {
  routeData: PROP_TYPES.PLANNED_AND_ACTUAL_ROUTE_DATA.isRequired,
  users: PropTypes.arrayOf(userPropTypes).isRequired,
  selectedUserIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedDate: PropTypes.string.isRequired,
  onStopClicked: PropTypes.func.isRequired,
};

function ActualVsPlannedCardHeader({ user, selectedDate }) {
  selectedDate = moment(selectedDate).format('DD MMM YYYY');
  return (
    <div id="actual-vs-planned-card-header" style={{ height: '20%' }}>
      <div>
        <div className="header-user-name">{`${user?.firstName} ${user?.lastName}`}</div>
        <div className="icon-header">{`${selectedDate}`}&nbsp;&nbsp;|&nbsp;&nbsp;Planned Vs Actual</div>
      </div>
    </div>
  );
}

ActualVsPlannedCardHeader.propTypes = {
  user: userPropTypes.isRequired,
  selectedDate: PropTypes.string.isRequired,
};

function PlannedRouteCard(props) {
  return <RouteCard {...props} label="Planned" color={ACTUAL_VS_PLANNED_PROPERTY.PLANNED.color} />;
}

function ActualRouteCard(props) {
  return <RouteCard {...props} label="Actual" color={ACTUAL_VS_PLANNED_PROPERTY.ACTUAL.color} />;
}

export default withOverlay(ActualVsPlannedCard);
